export const RELATED_EVENTS_ID = 'listings-root__related-events';
export const MORE_EVENTS_FROM_ID =
    'listings-root__more-events-from-this-organizer';
